import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LimitOffsetPaging } from 'app/core/models/paged-results/limit-offset-paging.model';
import { EncounterTypeEligibilitySummary } from 'app/core/models/encounter-type-eligibility-summary.model';
import { EncounterTypeEligibilitySummaryListComponent } from 'app/shared/components/encounter-type-eligibility-summary-list/encounter-type-eligibility-summary-list.component';
import { PaginationHeaderComponent } from 'app/shared/components/pagination-header/pagination-header.component';
import { PaginationComponent } from 'app/shared/components/pagination/pagination.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-encounter-type-eligibility-summary-table',
  templateUrl: './encounter-type-eligibility-summary-table.component.html',
  styleUrls: ['./encounter-type-eligibility-summary-table.component.scss'],
  imports: [
    EncounterTypeEligibilitySummaryListComponent,
    PaginationHeaderComponent,
    PaginationComponent,
    MatProgressSpinner,
  ],
})
export class EncounterTypeEligibilitySummaryTableComponent {
  @Input() paging: LimitOffsetPaging;
  @Input() loading: boolean;
  @Input() encounterTypeEligibilitySummaries: EncounterTypeEligibilitySummary[];
  @Input() label: string;

  @Output() pageSizeChange = new EventEmitter<number>();
  @Output() pageChange = new EventEmitter<number>();
}
